import Passage from '@app/components/ui/passage';
import Reveal from '@app/components/ui/reveal';
import { TestimonialDto } from '@app/models/dtos/contentDto';

export default function Testimonial({ testimonials }: { testimonials: TestimonialDto[] }) {
    const testimonial = testimonials[0];
    if (!testimonial) return null;

    return (
        <Passage id="words">
            <Reveal>
                <figure>
                    <blockquote className="t-body italic text-ink">“{testimonial.quote}”</blockquote>
                    <figcaption className="t-small mt-4 text-muted">
                        {testimonial.name}, {testimonial.position}
                    </figcaption>
                </figure>
            </Reveal>
        </Passage>
    );
}
